import http from "../common/http";
import authHeader from "./header";
import {
    SERVICE_API_URL
} from "../common/config";

const galleryFindAll = (params) => {
    return http.get(SERVICE_API_URL + `/galleries`, {
        params: params,
        headers: authHeader(),
    });
};

const galleryFindOne = (id, params) => {
    return http.get(SERVICE_API_URL + `/galleries/${id}`, {
        params: params,
        headers: authHeader(),
    });
};

const galleryFindOneByUserId = (params) => {
    return http.get(SERVICE_API_URL + `/galleries`, {
        params: params,
        headers: authHeader(),
    });
};

const regGallery = (params) => {
    return http.post(SERVICE_API_URL + `/galleries`, params, {
        headers: authHeader(),
    });
};

export default {
    galleryFindAll,
    galleryFindOne,
    regGallery,
    galleryFindOneByUserId
};